import React from "react";
import {useStakingContract, useStakingDispatch} from "../../context/StakingContract";
import {SET_ERROR_WITH_MESSAGE, STAKE_TX_HASH} from "../../context/StakingContract/actions";

const Confirm = ({ nextStep, lastStep }) => {
  const {stakingContract, state} = useStakingContract();
  const dispatch = useStakingDispatch();

  const onClickHandle = () => {
    const {staking} = state;
    console.log("staking click");
    stakingContract.stakeERD(staking.stakingValue.toString())
      .then(v => {
        if ( v === undefined ) {
          dispatch({type: SET_ERROR_WITH_MESSAGE, payload: "Your stake was not submitted"});
          lastStep();
          return;
        }
        dispatch({type: STAKE_TX_HASH, payload: v.hash});
        nextStep();
      }).catch(err => {
      console.warn("err", err);
      dispatch({type: SET_ERROR_WITH_MESSAGE, payload: "Something went wrong with your deposit, try again"});
      lastStep();
    });
  };
  const {staking} = state;
  return (
    <div className="card">
      <div className="card-body">
        <h3>Stake</h3>
        <p className="lead">2<sup>nd</sup> of 2 transactions required.</p>
        <p>Second transaction is the <strong>Stake</strong> step, where the provided amount of ERD tokens will be actually staked in the contract. This is the last transaction you need to make to finalize the staking.</p>
        <p className="mb-4"><strong>{staking.stakingValue.toLocaleString('en')} ERD</strong> - You are about to stake {staking.stakingValue.toLocaleString('en')} ERD.
          <br/>
          <small className="text-muted"><sup>*</sup> Make sure you have enough ETH to pay for transaction fees.</small>
        </p>
        <button className="btn btn-primary" onClick={onClickHandle}>
          Submit stake
        </button>
      </div>
    </div>
  );
};

export default Confirm;
